import type { FaireProductEntity } from "../../entity_types/product";

export const p_upnxt2sq6g: FaireProductEntity = {
  token: "p_upnxt2sq6g",
  type: "product",
  name: "Color Moissanite Pave Engagement Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/e54cca685715d5a42336792eace670201135274ef595ad9b0be0955060ad79e7.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6fc355c09f2ce8857ed2a8149e2c6a6d9209bce2133c6f743430f68f900d50c.webp",
    "https://cdn.faire.com/fastly/22248b6561756ae98f6eca5e787e3c029c0a02829b2f62ba74acc57bcc62e74d.png",
    "https://cdn.faire.com/fastly/af91475f13a4c4f111108c19a2651a3b80f103285d9e56daa4603a87e699df03.png",
    "https://cdn.faire.com/fastly/3d2d57156b5d0bdcd446682d957482474e1b5199cbac99ff0c674f12550580d1.png",
    "https://cdn.faire.com/fastly/d6ee54d9282b74ab88a7be2c6393aefeca3d1e29583e8eec383b51468f4de614.png",
    "https://cdn.faire.com/fastly/add52aaa9306ba851b66904522c985b97ebb5302bc39896926b915277b020536.png",
    "https://cdn.faire.com/fastly/0b77c2dae6718d327253cafa2c15142cac6afd66783a86d121e393506e360fd5.png",
  ],
  priceDollars: 29,
  description:
    "Description & Details\n\nExperience the brilliance and beauty of this exceptional gemstone. Each piece in our collection is meticulously crafted to showcase the mesmerizing sparkle and fire of moissanite, offering a stunning alternative to traditional diamond jewelry.\n\n• Material: Solid 925 Sterling Silver ∙ Certified Moissanite (Color D, VVS1)\n• Finish: Hypoallergenic ∙ 950 Platinum (Pt 950) Plating\n• Dimensions: 2.0 - 5.0 ct, Color D, VVS1 Moissanite, US size 5 - 9 available\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:23.933Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
